import * as React from 'react';
import { GuideTs } from 'locales';
import UI from 'styles/ui';

interface Iprops {
  messages: GuideTs;
}


const Guide = ({messages}: Iprops) => {
  return (
    <>
      <section>
        <UI.Title level={2}>Title Guide</UI.Title>
        <div>
          <UI.Title level={5}>{messages.test}</UI.Title>
          <UI.Title level={4}>{messages.test}</UI.Title>
          <UI.Title level={3}>{messages.test}</UI.Title>
          <UI.Title level={2}>{messages.test}</UI.Title>
          <UI.Title level={1}>{messages.test}</UI.Title>
          <UI.Title>{messages.test}</UI.Title>
        </div>
      </section>
      <section>
        <UI.Title level={2}>Button Guide</UI.Title>
        <div>
          <UI.Button shape="small">{messages.testBtn}</UI.Button>
          <UI.Button shape="small" color="confirm">{messages.testBtn}</UI.Button>
          <UI.Button shape="small" color="cancel">{messages.testBtn}</UI.Button>
          <UI.Button shape="small" color="buy">{messages.testBtn}</UI.Button>
          <UI.Button shape="small" color="sell">{messages.testBtn}</UI.Button>
          <UI.Button shape="small" color="sell" disabled={true}>{messages.testBtn}</UI.Button><br/><br/>
          <UI.Button>{messages.testBtn}</UI.Button>
          <UI.Button color="confirm">{messages.testBtn}</UI.Button>
          <UI.Button color="cancel">{messages.testBtn}</UI.Button>
          <UI.Button color="buy">{messages.testBtn}</UI.Button>
          <UI.Button color="sell">{messages.testBtn}</UI.Button>
          <UI.Button color="sell" disabled={true}>{messages.testBtn}</UI.Button><br/><br/>
          <UI.Button shape="large">{messages.testBtn}</UI.Button>
          <UI.Button shape="large" color="confirm">{messages.testBtn}</UI.Button>
          <UI.Button shape="large" color="cancel">{messages.testBtn}</UI.Button>
          <UI.Button shape="large" color="buy">{messages.testBtn}</UI.Button>
          <UI.Button shape="large" color="sell">{messages.testBtn}</UI.Button>
          <UI.Button shape="large" color="sell" disabled={true}>{messages.testBtn}</UI.Button><br/><br/>
          <UI.Button color="p-confirm">{messages.testBtn}</UI.Button>
          <UI.Button color="p-cancel">{messages.testBtn}</UI.Button>
        </div>
      </section>
      <section>
        <UI.Title level={2}>Input Guide</UI.Title>
        <div>
          <UI.InputArea>
            테스트
          </UI.InputArea>
        </div>
        <div>
          <UI.InputArea shape="small">
            테스트
          </UI.InputArea>
        </div>
        <div>
          이것도 테스트
          <UI.InputArea disabled={true}>
            테스트
          </UI.InputArea>
        </div>
        <div>
          <UI.InputArea>
            <UI.Input type="text" />
          </UI.InputArea>
          <UI.InputArea>
            테스트
          </UI.InputArea>
        </div>
        <div>
          <UI.InputArea>
            <UI.Input type="text" placeholder="example@mail.com" />
          </UI.InputArea>
          <UI.InputArea>
            테스트
          </UI.InputArea>
        </div>
        <div>
          <UI.InputArea shape="small">
            테스트
          </UI.InputArea>
        </div>
        <div>
          <UI.InputArea disabled={true}>
            테스트
          </UI.InputArea>
        </div>
      </section>
      <section>
        <UI.Title level={2}>Drop Down Guide</UI.Title>
        <div>
          <UI.Select />
        </div>
      </section>
      <section>
        <UI.Title level={2}>Drop Down Guide</UI.Title>
        <div>
          <UI.Select search={true} data={['1asadsadsadasdas', 'basdasdasd', '0', '0000', '0000', '0000', '0000', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345']} />
        </div>
      </section>
      <section>
        <UI.Title level={2}>Drop Down Guide</UI.Title>
        <div>
          <UI.Select maxList={10} data={['2asadsadsadasdas', 'basdasdasd', '0', '0000', '0000', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345', '012345']} />
        </div>
      </section>
      <section>
        <UI.Title level={2}>Drop Down Guide</UI.Title>
        <div>
          <UI.Select data={['3asadsadsadasdas', 'basdasdasd', '0', '0000', '012345']} maxList={2} />
        </div>
      </section>
      <section>
        <UI.Title level={2}>Drop Down Guide</UI.Title>
        <div>
          <UI.Select data={['4asadsadsadasdas', 'basdasdasd', '0', '0000', '012345']} />
        </div>
      </section>
      <section>
        <UI.Title level={2}>Drop Down Guide</UI.Title>
        <div>
          <UI.Select data={['5asadsadsadasdas', 'basdasdasd', '0', '0000', '012345']} maxList={1} />
        </div>
      </section>
    </>
  )
}


export default Guide



// WEBPACK FOOTER //
// ./src/pages/guide.tsx